module.exports = __webpack_public_path__ + "img/wash-stand-big.6dc01bd2.png";